import * as h2Api from '../h2Api'

export const LOAD_NEWS = 'LOAD_NEWS'

export const loadNewsFeed = () => dispatch => {
  return dispatch(h2Api.get('/announcements')({ type: LOAD_NEWS }))
}
